import { styled, Typography } from "@mui/material";
import { Button, Card, Tag } from "@volt_developers/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { TEST_IDS } from "constants/TestIds";

import type { ReactNode } from "react";

export interface ConfigureNotificationsCardProps {
  canConfigure: boolean;
  to: string;
  title?: ReactNode;
}

export function ConfigureNotificationsCard({
  canConfigure,
  to,
  title,
}: ConfigureNotificationsCardProps) {
  const { t } = useTranslation("common");

  return (
    <Card.Wrapper
      data-testid={TEST_IDS.notificationsConfigureCard}
      sx={{ mt: 2, mb: 2 }}
      gutterBottom
    >
      <Card.Body
        sxHeader={{ mb: 0.75 }}
        header={
          <HeaderWrapper>
            <Typography variant="h6">
              {title ?? t(COMMON_TRANSLATION_KEYS.notifications)}
            </Typography>
            <Tag label={t(COMMON_TRANSLATION_KEYS.notConfigured)} inactive />
          </HeaderWrapper>
        }
      >
        {!canConfigure && (
          <Card.Description sx={{ mb: 0 }}>
            {t(COMMON_TRANSLATION_KEYS.youDoNotHaveNotifications)}
          </Card.Description>
        )}
        <Card.Item sxContent={{ alignItems: "flex-start" }}>
          <Button
            component={Link}
            data-testid={TEST_IDS.notificationsConfigureButton}
            disabled={!canConfigure}
            sx={{ mt: !canConfigure ? 0.5 : 0.75 }}
            to={to}
          >
            {t(COMMON_TRANSLATION_KEYS.configure)}
          </Button>
        </Card.Item>
      </Card.Body>
    </Card.Wrapper>
  );
}

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
}));
